export default "<p>user-avator works!</p>\r\n";